import { FC, useEffect, useState } from "react";
import { Button, Paper, Stack, TextField, Typography } from "@mui/material";
import authenticationService from "@/services/api/AuthenticationService";
import UserService from "@/services/api/UserService";
import { authenticationLocalStorage } from "@/utils/constants/localStorage";
import Toast from "@/components/Toast/Toast";
import useToastStore from "@/services/store/useToastStore";

const Login: FC = () => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { setToast } = useToastStore();

  useEffect(() => {
    const params = new URLSearchParams(globalThis.location.search);
    if (params.get("reason") === "access_denied") {
      setToast({
        isOpen: true,
        type: "error",
        message: "Accès refusé : vous n'avez pas les droits superviseur pour accéder à cette application.",
      });
      globalThis.history.replaceState({}, "", "/login");
    }
  }, [setToast]);

  const handleLoginChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLogin(e.target.value);
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    authenticationService
      .login(login, password)
      .then(async (res) => {
        authenticationLocalStorage.setToken(res.token);
        const user = await UserService.getMe();
        authenticationLocalStorage.setLoggedUser(user);
        globalThis.location.href = "/";
      })
      .catch(() => {
        setErrorMessage("Nom d'utilisateur ou mot de passe invalide");
      });
  };

  return (
    <Stack justifyContent="center" alignItems="center" sx={{ width: "100%", height: "100vh" }}>
      <Toast />
      <Paper sx={{ width: "clamp(300px, 50%, 800px)", padding: 2 }} elevation={3}>
        <form onSubmit={onSubmit}>
          <Stack spacing={2} direction="column" alignItems="center">
            <TextField
              fullWidth
              label="Nom d'utilisateur"
              variant="outlined"
              defaultValue={login}
              onChange={handleLoginChange}
            />
            <TextField
              fullWidth
              label="Mot de passe"
              variant="outlined"
              defaultValue={password}
              type="password"
              onChange={handlePasswordChange}
            />
            <Button type="submit" variant="contained" sx={{ width: "50%" }}>
              Connexion
            </Button>
            <Typography sx={{ color: "red" }}>{errorMessage}</Typography>
          </Stack>
        </form>
      </Paper>
    </Stack>
  );
};

export default Login;
